import { zkLinkNova as viemZkLinkNova } from 'viem/chains';

import { defaultServices } from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const zkLinkNova = {
  displayName: 'zkLink Nova',
  runtime: 'evm',
  viemChain: viemZkLinkNova,
  isSupported: false,
  isMainnet: true,
  services: defaultServices({
    zerion: { chainKey: 'zklink-nova' },
  }),
} as const satisfies AllChainConfig<'evm', false>;
